import { Link, useLocation } from "react-router-dom";
import { Icon } from "@/components/common/icon";
import { sidebarNavConfig } from "@/config/nav";
import { Button } from "@rumble-it/common-components/components";
import { useTranslation } from "react-i18next";
import { buildMenuFromPermissions } from "@/lib/helpers/nav";
import { getConfigValue } from "@rumble-it/common-lib/src/config";
import { useAuth } from "react-oidc-context";

const Sidebar = ({ permissions, oidcRoles }) => {
  const { t } = useTranslation();
  const auth = useAuth();

  return (
    <aside className="w-[250px] min-w-[250px] h-screen max-h-screen flex flex-col">
      <div>
        <Link
          className="px-4 py-2 border-neutral-300 border-b h-[90px] flex justify-center items-center"
          to="/"
        >
          <img
            width={0}
            height={0}
            alt="RumbleDirect Logo"
            src={`${getConfigValue("cdnUrl")}/static/assets/logos/logo-rumble.svg`}
            className="max-h-[70%] max-w-[70%]"
            style={{ width: "auto", height: "auto" }}
          />
        </Link>
      </div>

      <nav className="flex flex-1 flex-col px-3 mt-3">
        <ul role="list" className="space-y-1.5">
          {Object.keys(
            buildMenuFromPermissions(permissions, oidcRoles).items,
          ).map((key) => {
            const item = sidebarNavConfig.items[key];
            return (
              <SidebarItem
                key={key}
                href={item.href}
                icon={item.icon}
                label={t(`gui.label.navigation.${key}`)}
              />
            );
          })}
        </ul>
      </nav>

      <div className="border-neutral-300 border-t w-full min-h-9 justify-self-end">
        <div className="text-center flex justify-center py-1">
          <Button
            type="button"
            onClick={auth.signoutRedirect}
            variant="greyLightNoBorder"
            size="iconSmall"
            faIcon={{ style: "fal", name: "right-from-bracket" }}
          />
        </div>
      </div>
    </aside>
  );
};

const SidebarItem = ({ icon, label, href }) => {
  const location = useLocation();
  const isActive = location.pathname === href;

  return (
    <li>
      <Link
        to={href || "/"}
        className={`hover:bg-neutral-200 w-full pl-3 pr-2 py-3 flex rounded-full transition-colors duration-200 items-center font-medium ${
          isActive ? "bg-neutral-200" : ""
        }`}
      >
        <div className="w-5 h-5 p-[3px] flex mr-3 justify-center items-center">
          {icon ? <Icon faIcon={icon} className="w-full h-full" /> : null}
        </div>
        <span>{label}</span>
      </Link>
    </li>
  );
};

export { Sidebar };
